import {
    AccessBayScheduling,
    AccessHaulerManagement,
    AccessPlantManagement,
    AccessProducerManagement,
    CanImpersonateUsers,
    Dashboard,
    GetMilkScheduleDetails,
    ListAdmins,
    ListCIPWash,
    ListDrivers,
    ListDropoffs,
    ListHaulingCompanies,
    ListInvoicing,
    ListLabReports,
    ListManifests,
    ListMonthlyReports,
    ListPickups,
    ListPickupsAndLabs,
    ListProcessors,
    ListProducers,
    ListRouteSessions,
    ListScheduleRoutes,
    ListSharedFiles,
    ListSubAdmins,
    ListSubHauling,
    ListSubProcessors,
    ListSubProducers,
    ListTrailers,
    ListUserGroups,
    ListUserGroupsV2,
    ManageAssignees,
    ManageBankingInfo,
    ManageClosePeriod,
    ManageCustomFields,
    ManageDeferrals,
    ManageDeliveryReports,
    ManageEquity,
    ManageHaulerPayReports,
    ManageLinkedUsers,
    ManageMerchandise,
    ManageMilkPrices,
    ManageMooRules,
    ManagePaymentStatus,
    ManagePoolingDecisions,
    ManageProcessedFluidsPickups,
    ManageProcessorTotals,
    ManageProducerPayReports,
    ManageProducerTouchBases,
    ManageSplitProducers,
    ManageVendorPayReports,
    ProducerHaulingContractsAndCharges,
    UploadDownload,
    UploadMooRules,
    ViewAccountingReports,
    ViewDocumentation,
    ViewDriverLocations,
    ViewHaulerPayReport,
    ViewMilkPredictionReport,
    ViewPricing,
    ViewContractPerformanceReport,
    ViewSupplyOutlookReport,
} from './permissions';
import LABELS from './constants';

const region = 'PSC';

const SubAdminManagement = {
    label: LABELS.Management,
    permissions: [
        ListSubAdmins,
        ListAdmins,
        ListProducers,
        ListSubProducers,
        ListProcessors(region),
        ListSubProcessors(region),
        ListTrailers,
        ListHaulingCompanies(region),
        ListSubHauling(region),
        ListDrivers,
        ManageLinkedUsers,
        CanImpersonateUsers,
        // force wrap
    ],
};

const SubAdminGeneral = {
    label: LABELS.General,
    permissions: [
        Dashboard,
        ManageDeliveryReports,
        UploadDownload,
        ListScheduleRoutes,
        ListLabReports(),
        ListPickups(),
        ListDropoffs(),
        ListRouteSessions(region),
        ViewDriverLocations,
        ManageEquity,
        ListCIPWash,
        ListManifests,
        ListUserGroups,
        ListUserGroupsV2,
        GetMilkScheduleDetails(),
        ListSharedFiles,
        ViewDocumentation,
        ManageClosePeriod,
        AccessPlantManagement,
        AccessHaulerManagement,
        AccessProducerManagement,
        AccessBayScheduling,
        ManageCustomFields,
        ViewMilkPredictionReport,
        ViewContractPerformanceReport,
        ViewSupplyOutlookReport,
    ],
};

const SubAdminPooling = {
    label: LABELS.Pooling,
    permissions: [
        ManagePoolingDecisions,
        ManageProcessorTotals,
        ManageProducerTouchBases,
        // force wrap
    ],
};

const SubAdminAccounting = {
    label: LABELS.Accounting,
    permissions: [
        ViewAccountingReports,
        ManageMerchandise(region),
        ManageAssignees,
        ManageMilkPrices,
        ManageDeferrals,
        ManageSplitProducers,
        ManageProducerPayReports,
        ManageHaulerPayReports,
        ManageVendorPayReports,
        ManagePaymentStatus,
        ManageBankingInfo,
        ManageMooRules,
        UploadMooRules,
        ViewPricing,
        // force wrap
    ],
};

const SubProducerManagement = {
    label: LABELS.Management,
    permissions: [ListSubProducers],
};

const SubProducerGeneral = {
    label: LABELS.General,
    permissions: [
        Dashboard,
        ListPickups('View', ''),
        ListPickupsAndLabs,
        ListLabReports('View', ''),
        ListSharedFiles,
        AccessProducerManagement,
        // force wrap
    ],
};

const SubProducerAccounting = {
    label: LABELS.Accounting,
    permissions: [ListMonthlyReports(region)],
};

const SubProcessorManagement = {
    label: LABELS.Management,
    permissions: [ListSubProcessors(region)],
};

const SubProcessorGeneral = {
    label: LABELS.General,
    permissions: [
        Dashboard,
        ManageProcessedFluidsPickups,
        ListSharedFiles,
        ListInvoicing,
        GetMilkScheduleDetails(),
        AccessPlantManagement,
        AccessBayScheduling,
        // force wrap
    ],
};

const SubHaulingManagement = {
    label: LABELS.Management,
    permissions: [ListSubHauling(region), ListDrivers, ListTrailers],
};

const SubHaulingGeneral = {
    label: LABELS.General,
    permissions: [
        Dashboard,
        GetMilkScheduleDetails('View', ''),
        ListSharedFiles,
        ListCIPWash,
        AccessHaulerManagement,
        // force wrap
    ],
};

const SubHaulingAccounting = {
    label: LABELS.Accounting,
    permissions: [ViewHaulerPayReport, ProducerHaulingContractsAndCharges],
};

const SubAdmin = [SubAdminManagement, SubAdminGeneral, SubAdminAccounting, SubAdminPooling];
const SubProducer = [SubProducerManagement, SubProducerGeneral, SubProducerAccounting];
const SubProcessor = [SubProcessorManagement, SubProcessorGeneral];
const SubHauling = [SubHaulingManagement, SubHaulingGeneral, SubHaulingAccounting];

const REQUIRED_PERMISSIONS = {
    Admin: [
        ListUserGroups,
        ManageClosePeriod,
        ListManifests,
        GetMilkScheduleDetails(),
        ListTrailers,
        // force-wrap
    ],
};

const PSC = {
    Admin: { permissions: SubAdmin, required: REQUIRED_PERMISSIONS.Admin },
    'Sub-Admin': { permissions: SubAdmin },
    'Sub-Producer': { permissions: SubProducer },
    Accountant: { permissions: SubProducer },
    'Feed-Provider': { permissions: SubProducer },
    Nutritionist: { permissions: SubProducer },
    'Co-Owner': { permissions: SubProducer },
    'Sub-Processor': { permissions: SubProcessor },
    'Sub-Hauling': { permissions: SubHauling },
    Processor: { permissions: SubProcessor },
    Hauling: { permissions: SubHauling },
};

export default PSC;
